module.exports = __webpack_public_path__ + "img/website2.f8a5ff57.svg";